import { useMemo } from 'react'; // Is single item selected in a multiselect dropdown

function isMultiSelect(selectedItem) {
  return Array.isArray(selectedItem) && selectedItem.length === 1;
}
/**
 * aria-setsize and aria-posinset attributes to be set on the dropdown button value node when the dropdown is collapsed
 * **/


export function useDropdownSelectionAriaAttributes(selectedItem, source) {
  return useMemo(function () {
    var ariaAttributes = {
      'aria-setsize': (source ? source.length : 0).toFixed(0),
      'aria-selected': 'true'
    };

    if (source && selectedItem != null && !isMultiSelect(selectedItem)) {
      var selectedIndex = source.indexOf(selectedItem);

      if (selectedIndex !== -1) {
        ariaAttributes['aria-posinset'] = (selectedIndex + 1).toFixed(0);
      }
    }

    return ariaAttributes;
  }, [selectedItem, source]);
}
//# sourceMappingURL=useDropdownSelectionAriaAttributes.js.map